import React, { Component } from "react";
import ApprovalConfForm from "../ApprovalConfForm/ApprovalConfForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : ApprovalConfPage
Description : Componente que invoca al componente ApprovalConfForm
Date Autor Modification
================================================================================
14/04/2026 scoca – Creacióm
================================================================================ */
class ApprovalConfPage extends Component {
    render() {
        return (
            <ApprovalConfForm />
        )
    }
}

export default ApprovalConfPage;